class BurgerMenu extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.burgerMenu = this.querySelector(".burger-menu");
		this.openButton = this.querySelector(".burger-menu__toggle--open-btn");
		this.openhoverButton = this.querySelector(".burger-menu__hover--open-btn");
		this.closeButton = this.querySelectorAll(".burger-menu__toggle--close-btn");
		this.overlay = this.querySelector(".burger-menu__overlay");
		this._hoverCloseTimer = null;

		if (this.header) this.header.preventHide = false;

		this.setListeners();
	}

	get isHoverMode() {
		return this.dataset.openOnHover === 'true';
	}

	static clearAllHoverTimers() {
		document.querySelectorAll("burger-menu").forEach((el) => {
			clearTimeout(el._hoverCloseTimer);
			el._hoverCloseTimer = null;
		});
	}

	_closeOtherMenus() {
		document.querySelectorAll("burger-menu").forEach((other) => {
			if (other === this) return;
			const otherBurger = other.querySelector(".burger-menu");
			if (otherBurger && otherBurger.classList.contains("burger-menu--open")) {
				clearTimeout(other._hoverCloseTimer);
				other._hoverCloseTimer = null;
				otherBurger.classList.remove("burger-menu--open");
				otherBurger.querySelector(".burger-menu__overlay")?.classList?.remove("burger-menu__overlay--active");
				other._resetOwnDropdown();
			}
		});
	}

	_updateHeaderBackground(menuOpening) {
		const headerSection = document.querySelector(".shopify-section-header");
		if (!headerSection) return;
		const hasEntering = headerSection.classList.contains("entering-section");
		const hasColor1 = headerSection.classList.contains("color-background-1");

		if (menuOpening) {
			if (hasColor1 && headerSection.classList.contains("color-background-2")) {
				headerSection.classList.remove("color-background-2");
			}
		} else {
			if (hasColor1 && hasEntering) {
				headerSection.classList.add("color-background-2");
			}
		}
	}

	open(event) {
		if (event) event.preventDefault();
		if (this.header) this.header.preventHide = true;

		clearTimeout(this._hoverCloseTimer);
		this._hoverCloseTimer = null;

		this._closeOtherMenus();

		this.burgerMenu.classList.add("burger-menu--open");
		this.overlay.classList.add("burger-menu__overlay--active");
		if (!this.isHoverMode) {
			document.body.classList.add("overflow-hidden-drawer");
		}
		this._setOwnDropdownPosition();
		this._updateHeaderBackground(true);
	}

	close(event) {
		if (event) event.preventDefault();

		if (!this.burgerMenu.classList.contains("burger-menu--open")) return;

		this.burgerMenu.classList.remove("burger-menu--open");
		this.overlay.classList.remove("burger-menu__overlay--active");
		document.body.classList.remove("overflow-hidden-drawer");

		const anyOpen = document.querySelector(".burger-menu--open");

		if (this.header) {
			if (!anyOpen) {
				this.header.preventHide = false;
			}
		}

		if (!anyOpen) {
			this._updateHeaderBackground(false);
		}

		if (this.isHoverMode) {
			this._resetOwnDropdown();
		} else {
			this.burgerMenu.classList.add("hiding");
			setTimeout(() => this.burgerMenu.classList.remove("hiding"), 700);
			this._resetOwnDropdown();
		}
	}

	_setOwnDropdownPosition() {
		const dropdownWrapper = this.querySelector('.burger-menu__dropdown-wrapper');
		if (!dropdownWrapper) return;

		const header = document.querySelector(".shopify-section-header");
		const burgerMenu = this.burgerMenu;
		const calcTranslatePosition = `${this.getElementHeight(header)}px`;

		dropdownWrapper.style.transform = 'translateY(0)';
		burgerMenu.style.top = calcTranslatePosition;

		if (this.isHoverMode) {
			dropdownWrapper.style.opacity = '1';
		} else {
			const burgerMenuOverlay = this.querySelector(".burger-menu__overlay");
			if (burgerMenuOverlay) burgerMenuOverlay.style.top = calcTranslatePosition;
		}
	}

	_resetOwnDropdown() {
		const dropdownWrapper = this.querySelector('.burger-menu__dropdown-wrapper');
		if (!dropdownWrapper) return;

		const header = document.querySelector(".shopify-section-header");
		const announcement = document.querySelector(".section-announcement");
		const countdownTimerBar = document.querySelector(".section-countdown-timer-bar");

		const offset = this.getElementHeight(header) + this.getElementHeight(announcement) + this.getElementHeight(countdownTimerBar);
		dropdownWrapper.style.transform = `translateY(calc(-100% - ${offset}px))`;

		if (dropdownWrapper.classList.contains('burger-menu__on-hover')) {
			dropdownWrapper.style.opacity = '0';
		}

		if (this.burgerMenu) {
			this.burgerMenu.style.top = '0';
		}
		const burgerMenuOverlay = dropdownWrapper.previousElementSibling;
		if (burgerMenuOverlay) {
			burgerMenuOverlay.style.top = '0';
		}
	}

	setListeners() {
		if (this.isHoverMode) {
			this.openhoverButton?.addEventListener("mouseenter", () => {
				BurgerMenu.clearAllHoverTimers();
				this.open();
			});

			this.burgerMenu?.addEventListener("mouseenter", () => {
				clearTimeout(this._hoverCloseTimer);
				this._hoverCloseTimer = null;
			});

			this.openhoverButton?.addEventListener("mouseleave", () => {
				clearTimeout(this._hoverCloseTimer);
				this._hoverCloseTimer = setTimeout(() => this.close(), 250);
			});

			this.burgerMenu?.addEventListener("mouseleave", () => {
				clearTimeout(this._hoverCloseTimer);
				this._hoverCloseTimer = setTimeout(() => this.close(), 250);
			});

			if (this.openhoverButton?.classList.contains("mega-menu__parent-link--no-click")) {
				this.openhoverButton.addEventListener("click", (e) => {
					e.preventDefault();
					this.open(e);
				});
			}
		}

		this.openButton?.addEventListener("click", (event) => this.open(event));
		this.closeButton?.forEach((item) =>
			item.addEventListener("click", (event) => this.close(event))
		);
		this.overlay?.addEventListener("click", (event) => this.close(event));
		this.burgerMenu?.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close(event)
		);
	}

	setDropdownWrapperPosition(el) { this._setOwnDropdownPosition(); }
	clearDropdownWrapperPosition() { this._resetOwnDropdown(); }

	getElementHeight(el) {
		if (!el) return 0;
		if (this.isElementInViewport(el)) {
			return el?.getBoundingClientRect()?.height || 0;
		}
		return 0;
	}

	isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top < window.innerHeight &&
			rect.bottom > 0 &&
			rect.left < window.innerWidth &&
			rect.right > 0
		);
	}
}

if (!customElements.get("burger-menu")) {
	customElements.define("burger-menu", BurgerMenu);
}
